import React from "react";
import "../Assets/css/printing.css";
import vid1 from "../Assets/videos/3d_printing_banner_video.mp4";
import Aerosapce from "../Assets/hhg_imgs/48_1.png"

import ARCHITECTURE from "../Assets/hhg_imgs/48_2.png"
import MEDICAL from "../Assets/hhg_imgs/48_3.png"
import AUTOMOTIVE from "../Assets/hhg_imgs/48_4.png"
import CASTING from "../Assets/hhg_imgs/48_5.png"
import ELECTRONIC from "../Assets/hhg_imgs/48_6.png"
import hhg_img from "../Assets/hhg_imgs/47_1.jpg"
import hhg_img1 from "../Assets/hhg_imgs/47_.jpg"
import sls from "../Assets/img/sls.png"
import dmls from "../Assets/img/icon3.png";
import fdm from "../Assets/img/icon2.png";
import faCube from "../Assets/icon/scan blue.png";
import  faPrint from "../Assets/icon/printing blue.png";
import faDraftingCompass from "../Assets/icon/design blue.png";

const Printing = () => {
  return (
    <>
  <div class="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
	<div id="page" class="jkit-template  site">
		<div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
			<div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
				<div class="elementor-element elementor-element-bdbb4a9 e-flex e-con-boxed e-con e-parent" data-id="bdbb4a9" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
						<div class="elementor-element elementor-element-2d2b035 e-con-full e-flex e-con e-child" data-id="2d2b035" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
							<div class="elementor-element elementor-element-30e7754 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-heading" data-id="30e7754" data-element_type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="heading.default">
								{/* <div class="elementor-widget-container">
									<h5 class="elementor-heading-title elementor-size-default"></h5>		
								</div> */}
							</div>
							<div class="elementor-element elementor-element-641798f elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="641798f" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:200,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_animated_text.default">
								<div class="elementor-widget-container">
									<div  class="jeg-elementor-kit jkit-animated-text jeg_module_1050_2_676b7a2b716bd"  data-style="highlighted" data-text="Revolution" data-shape="underline">
										<h1 class="animated-text">
                    <span class="dynamic-wrapper style-color">
												<span class="dynamic-text">Swift</span>
												
											</span>
											<span class="normal-text style-color"> Prototyping & Limited
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
													<path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/>
												</svg>
											</span>
											<span class="dynamic-wrapper style-color">
												<span class="dynamic-text"> Production</span>
												
											</span>
											<span class="normal-text style-color">  Solutions</span>
										</h1>
									</div>
								</div>
							</div>
							<div class="elementor-element elementor-element-12b1148 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor" data-id="12b1148" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:300,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="text-editor.default">
								<div class="dynamic-text">
                TIME, MONEY, QUALITY : WE DELIVER
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="elementor-element elementor-element-a5863ef e-flex e-con-boxed e-con e-parent" data-id="a5863ef" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
				<div className="e-con-inner">
    <div className="elementor-element elementor-element-c30c61e e-flex e-con-boxed e-con e-child" data-id="c30c61e" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}'>
        <div className="e-con-inner">
            <div className="elementor-element elementor-element-f9e7f13 e-flex e-con-boxed e-con e-child" data-id="f9e7f13" data-element_type="container" data-settings='{"content_width":"boxed"}'>
                <div className="e-con-inner">
                    <div className="elementor-element elementor-element-e0929bb e-con-full e-flex e-con e-child" data-id="e0929bb" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
                        <video 
                            className="custom-video" 
                            autoPlay 
                            muted 
                            loop 
                            playsInline 
                            ref={(video) => { if (video) video.play(); }} // Ensuring autoplay
                        >
                            <source src={vid1} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


</div>

		<div class="elementor-element elementor-element-3fd02d5 e-flex e-con-boxed e-con e-parent1" data-id="3fd02d5" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
		<div class="elementor-element elementor-element-836cbbe e-con-full e-flex e-con e-child" data-id="836cbbe" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		<div class="elementor-element elementor-element-b29317c e-con-full e-flex e-con e-child" data-id="b29317c" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">

         <div class="elementor-element elementor-element-db0e5e2 e-con-full e-flex e-con e-child" data-id="db0e5e2" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-869af5c elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="869af5c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h5 class="elementor-heading-title elementor-size-default"> We Have </h5>     </div>
                </div>
                <div class="elementor-element elementor-element-8407bdb elementor-widget__width-inherit elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading" data-id="8407bdb" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default"> House Technological</h2>        </div>
                </div>
                <div class="elementor-element elementor-element-ceb0f99 elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_feature_list" data-id="ceb0f99" data-element_type="widget" data-widget_type="jkit_feature_list.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-feature-list icon-position-left icon-position-left icon-position-left jeg_module_1050_9_676b7a2b8a3d4" ><ul class="feature-list-items shape-circle shape-view-stacked connector-type-classic"><li class="feature-list-item elementor-repeater-item-5c9e9bc">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title">Direct Metal Laser Sintering:</h4><p class="feature-list-content">Direct Metal Laser Sintering(DMLS) is a metal 3D printing technology which selectively fuses fine metal powders. HHG Industries has one EOS M290 machine in-house to offer various metal additive manufacturing service. We
                    can 3D print various metals like Chromium Cobalt, Tool Steel, Maraging Steel, Aluminium.</p>
                </div>
            </li><li class="feature-list-item elementor-repeater-item-0b496d9">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title">Plastic Laser Sintering:</h4>
                    <p class="feature-list-content">Plastic Laser Sintering is a
                additive manufacturing (AM) technology that uses a high-power laser to sinter small particles of polymer
                powder into a solid structure based on a 3D modal. It has been a popular choice for engineers and
                manufacturers for decades. The process involves dispersing the powder in a thin layer on a platform
                inside the build chamber. The laser scans a cross-section of the 3D model, heating the powder to just
                below or at the melting point of the material, fusing the particles together to create a solid part.</p>
                </div>
            </li><li class="feature-list-item elementor-repeater-item-de24195">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title">Fused Deposition Modeling:</h4>
                    <p class="feature-list-content">Fused Deposition Modeling(FDM),
                also known as fused filament fabriation(FFF), is the most popular 3D printing technology. It's widely
                used by everyday makers and consumers. With FDM technology at our fingertips, we're not just creating
                parts; we're shaping the future, layer by layer.</p>
                </div>
            </li>
            {/* <li class="feature-list-item elementor-repeater-item-de24195">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title">Bending and Folding:</h4>
                    <p class="feature-list-content">We create intricate profiles, channels, and angles.</p>
                </div>
            </li> */}
            {/* <li class="feature-list-item elementor-repeater-item-de24195">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title">Metal Fabrication</h4>
                    <p class="feature-list-content">From sheet metal to structural components, our solutions optimize welding processes.</p>
                </div>
            </li> */}
            </ul></div>     </div>
                </div>
                </div>
				</div>
		<div class="elementor-element elementor-element-9ee2b7b e-con-full e-flex e-con e-child" data-id="9ee2b7b" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-6f785b5 elementor-widget elementor-widget-image-carousel" data-id="6f785b5" data-element_type="widget" data-settings="{&quot;slides_to_show&quot;:&quot;1&quot;,&quot;navigation&quot;:&quot;none&quot;,&quot;autoplay_speed&quot;:4000,&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;infinite&quot;:&quot;yes&quot;,&quot;effect&quot;:&quot;slide&quot;,&quot;speed&quot;:500}" data-widget_type="image-carousel.default">
				<div class="elementor-widget-container">
					<div class="elementor-image-carousel-wrapper swiper" dir="ltr">
			<div class="elementor-image-carousel swiper-wrapper swiper-image-stretch" aria-live="off">
								<div class="swiper-slide" role="group" aria-roledescription="slide" aria-label="1 of 2">
                  <figure class="swiper-slide-inner">
                    <img decoding="async" class="swiper-slide-image" src={hhg_img} alt="" /></figure></div><div class="swiper-slide" role="group" aria-roledescription="slide" aria-label="2 of 2">
                      <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image" src={hhg_img1} alt="" /></figure></div>			</div>
							
									</div>
				</div>
				</div>
				</div>
        
				</div>
					</div>
     
				</div>
        <div class="elementor-element elementor-element-b29317c e-con-full e-flex e-con e-child" data-id="b29317c" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}" style={{display:'grid', justifyContent:'space-around'}}>
                <div class="elementor-element elementor-element-d400f8d elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="d400f8d" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h5 class="elementor-heading-title elementor-size-default" style={{textAlign:'center'}}>Discover The Additive Manufacturing Application </h5>       </div>
                </div>
                <div class="elementor-element elementor-element-93b6ef8 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget elementor-widget-jkit_heading" data-id="93b6ef8" data-element_type="widget" data-widget_type="jkit_heading.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-heading  align-left align-tablet- align-mobile- jeg_module_1050_4_676b7a2b79e09" ><div class="heading-section-title  display-inline-block"><h4 class="heading-title" ><span class="style-color" >Create Beyond Your Imagination</span></h4></div></div>       </div>
                </div>
                
                </div>
        </div>
      </div>
		  </div>
	</div>
 <div>
  <>

 <div data-elementor-type="wp-page" data-elementor-id="1403" class="elementor elementor-1403">
   
  <section class="elementor-section elementor-top-section elementor-element elementor-element-8df6f8e elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="8df6f8e" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
  
   <div class="elementor-container elementor-column-gap-default">
    
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3a6e651" data-id="3a6e651" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-8b4e406 elementor-widget elementor-widget-jkit_post_block" data-id="8b4e406" data-element_type="widget" data-widget_type="jkit_post_block.default">
            <div class="elementor-widget-container">
              <div class="jeg-elementor-kit jkit-postblock postblock-type-3 jkit-pagination-loadmore post-element jeg_module_1403_3_676b7a3184d8e"  data-id="jeg_module_1403_3_676b7a3184d8e" data-settings="{&quot;post_type&quot;:&quot;post&quot;,&quot;number_post&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:6,&quot;sizes&quot;:[]},&quot;post_offset&quot;:0,&quot;unique_content&quot;:&quot;disable&quot;,&quot;include_post&quot;:&quot;&quot;,&quot;exclude_post&quot;:&quot;&quot;,&quot;include_category&quot;:&quot;&quot;,&quot;exclude_category&quot;:&quot;&quot;,&quot;include_author&quot;:&quot;&quot;,&quot;include_tag&quot;:&quot;&quot;,&quot;exclude_tag&quot;:&quot;&quot;,&quot;sort_by&quot;:&quot;latest&quot;,&quot;pagination_mode&quot;:&quot;loadmore&quot;,&quot;pagination_loadmore_text&quot;:&quot;Load More&quot;,&quot;pagination_loading_text&quot;:&quot;Loading...&quot;,&quot;pagination_number_post&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:3,&quot;sizes&quot;:[]},&quot;pagination_scroll_limit&quot;:0,&quot;pagination_icon&quot;:{&quot;value&quot;:&quot;&quot;,&quot;library&quot;:&quot;&quot;},&quot;pagination_icon_position&quot;:&quot;before&quot;,&quot;st_category_position&quot;:&quot;left&quot;,&quot;sg_content_postblock_type&quot;:&quot;type-3&quot;,&quot;sg_content_element_order&quot;:&quot;title,meta,excerpt,read&quot;,&quot;sg_content_breakpoint&quot;:&quot;tablet&quot;,&quot;sg_content_title_html_tag&quot;:&quot;h3&quot;,&quot;sg_content_category_enable&quot;:&quot;yes&quot;,&quot;sg_content_excerpt_enable&quot;:&quot;&quot;,&quot;sg_content_excerpt_length&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;18&quot;,&quot;sizes&quot;:[]},&quot;sg_content_excerpt_more&quot;:&quot;...&quot;,&quot;sg_content_readmore_enable&quot;:&quot;&quot;,&quot;sg_content_readmore_icon&quot;:{&quot;value&quot;:&quot;fas fa-arrow-right&quot;,&quot;library&quot;:&quot;fa-solid&quot;},&quot;sg_content_readmore_icon_position&quot;:&quot;after&quot;,&quot;sg_content_readmore_text&quot;:&quot;Read More&quot;,&quot;sg_content_comment_enable&quot;:&quot;&quot;,&quot;sg_content_comment_icon&quot;:{&quot;value&quot;:&quot;fas fa-comment&quot;,&quot;library&quot;:&quot;fa-solid&quot;},&quot;sg_content_comment_icon_position&quot;:&quot;before&quot;,&quot;sg_content_meta_enable&quot;:&quot;yes&quot;,&quot;sg_content_meta_author_enable&quot;:&quot;yes&quot;,&quot;sg_content_meta_author_by_text&quot;:&quot;by &quot;,&quot;sg_content_meta_author_icon&quot;:{&quot;value&quot;:&quot;&quot;,&quot;library&quot;:&quot;&quot;},&quot;sg_content_meta_author_icon_position&quot;:&quot;before&quot;,&quot;sg_content_meta_date_enable&quot;:&quot;yes&quot;,&quot;sg_content_meta_date_type&quot;:&quot;published&quot;,&quot;sg_content_meta_date_format&quot;:&quot;default&quot;,&quot;sg_content_meta_date_format_custom&quot;:&quot;F j, Y&quot;,&quot;sg_content_meta_date_icon&quot;:{&quot;value&quot;:&quot;&quot;,&quot;library&quot;:&quot;&quot;},&quot;sg_content_meta_date_icon_position&quot;:&quot;before&quot;,&quot;sg_content_image_size_imagesize_size&quot;:&quot;full&quot;,&quot;paged&quot;:1,&quot;class&quot;:&quot;jkit_post_block&quot;}"><div class="jkit-block-container"><div class="jkit-posts jkit-ajax-flag">
<article class="jkit-post post-1437 post type-post status-publish format-standard has-post-thumbnail hentry category-tips-trick tag-industrial-robot">
    <div class="jkit-thumb"><a><div class="thumbnail-container ">
    <img decoding="async" width="1920" height="19081" src={Aerosapce} class="thumbnail-container" alt="Aerosapce" sizes="" />
    </div></a><div class="jkit-post-category position-left"><span><a  class="category-tips-trick"> AEROSAPCE</a></span></div></div>
</article>

        
<article class="jkit-post post-1437 post type-post status-publish format-standard has-post-thumbnail hentry category-tips-trick tag-industrial-robot">
  <div class="jkit-thumb"><a><div class="thumbnail-container ">
    <img decoding="async" width="1920" height="1081" src={ARCHITECTURE} class="thumbnail-container" alt="ARCHITECTURE" sizes="" />
      </div></a><div class="jkit-post-category position-left"><span><a  class="category-tips-trick"> ARCHITECTURE</a></span></div></div>
</article>

<article class="jkit-post post-1437 post type-post status-publish format-standard has-post-thumbnail hentry category-tips-trick tag-industrial-robot">
    <div class="jkit-thumb"><a><div class="thumbnail-container ">
      <img decoding="async" width="1920" height="1081" src={MEDICAL} class="thumbnail-container" alt="MEDICAL" sizes="" />
        </div></a><div class="jkit-post-category position-left"><span><a  class="category-tips-trick"> MEDICAL</a></span></div></div>
</article>

<article class="jkit-post post-1437 post type-post status-publish format-standard has-post-thumbnail hentry category-tips-trick tag-industrial-robot">
  <div class="jkit-thumb"><a><div class="thumbnail-container ">
    <img decoding="async" width="1920" height="1081" src={AUTOMOTIVE} class="thumbnail-container" alt="AUTOMOTIVE" sizes="" />
      </div></a><div class="jkit-post-category position-left"><span><a  class="category-tips-trick"> AUTOMOTIVE</a></span></div></div>
</article>
<article class="jkit-post post-1437 post type-post status-publish format-standard has-post-thumbnail hentry category-tips-trick tag-industrial-robot">
  <div class="jkit-thumb"><a><div class="thumbnail-container ">
    <img decoding="async" width="1920" height="1081" src={CASTING} class="thumbnail-container" alt="CASTING" sizes="" />
      </div></a><div class="jkit-post-category position-left"><span><a  class="category-tips-trick"> CASTING</a></span></div></div>
</article>
<article class="jkit-post post-1437 post type-post status-publish format-standard has-post-thumbnail hentry category-tips-trick tag-industrial-robot">
<div class="jkit-thumb"><a><div class="thumbnail-container ">
  <img decoding="async" width="1920" height="1081" src={ELECTRONIC} class="thumbnail-container" alt="ELECTRONIC" sizes="" /></div>
    </a><div class="jkit-post-category position-left"><span><a  class="category-tips-trick"> ELECTRONIC</a></span></div></div>
    </article>
  
      </div>
  
       </div>
        </div>
          </div>
            </div>
              </div>
                 </div>
                  </div>
                    </section>
                      </div>
 </>
 
             
        
 <div className="printing-container">
 <div className="printing-container">
 
        <spa><h2>Ease Of Process Selection</h2></spa>
      </div>
      <section className="printing-container">
    
         <table className="process-table">
          <thead>
            <tr>
              <th></th>
              <th>
                <img src={sls} width="28" alt="SLS" />
                <br /> SLS
              </th>
              <th>
                <img src={dmls} width="28" alt="DMLS" />
                <br /> DMLS
              </th>
              <th>
                <img src={fdm} width="28" alt="FDM" />
                <br /> FDM
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Typical Lead Time</th>
              <td>5 - 7 days</td>
              <td>7 - 9 days</td>
              <td>3 - 5 days</td>
            </tr>
            <tr>
              <th>Material Type</th>
              <td>Polymer</td>
              <td>Metal</td>
              <td>Polymer</td>
            </tr>
            <tr>
              <th>Accuracy</th>
              <td>⨀</td>
              <td>⨀⨀</td>
              <td>⨀</td>
            </tr>
            <tr>
              <th>Surface Finish</th>
              <td>∆</td>
              <td>∆∆</td>
              <td>∆</td>
            </tr>
            <tr>
              <th>Part Strength</th>
              <td>**</td>
              <td>***</td>
              <td>**</td>
            </tr>
            <tr>
              <th>Price</th>
              <td>₹</td>
              <td>₹₹</td>
              <td>₹</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="about-us">
  <h2 className="title">
    <span className="highlight">BEYOND 3D PRINTING</span>
  </h2>
  <p className="feature-list-content">
    At our company, we go beyond 3D printing to provide a comprehensive range of services.
    Whether it’s scanning, design consultation, or finishing touches, our skilled technicians
    are dedicated to pushing the boundaries and ensuring your ideas achieve their full potential.
    Let us take your project to the next level.
  </p>
  <div className="icons">
        <div className="icon-item">
          <img src={faCube} className="icon" />
          <span>3D SCAN</span>
        </div>
        <div className="icon-item">
          <img src={faPrint} className="icon" />
          <span>3D PRINT</span>
        </div>
        <div className="icon-item">
          <img src={faDraftingCompass} className="icon" />
          <span >3D DESIGN</span>
        </div>
      </div>
</section>

<section className="services">
  <h2>Empower Your Journey With Credible Advisors</h2>
  <p className="feature-list-content">
    We provide high-quality parts with a guarantee. Our 3D print services prioritize accuracy
    and quality, ensuring meticulous attention to your requests.
  </p>
  
  <div className="process-flow">
    {/* You can add your process steps here */}
  </div>

  {/* <div className="button-group">
    <button className="btn-modern btn-primary">Talk To Expert</button>
    <button className="btn-modern btn-secondary">Design/Scanning Quote</button>
    <button className="btn-modern btn-secondary">3D Print Quote</button>
  </div> */}
</section>

    </div>
    </div>
    </>
  );
};

export default Printing;
